import React, { useState, useEffect } from "react";

const Hitechservices = () => {
  const [activeTab, setActiveTab] = useState("Digital Engineering");
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 800);
    return () => clearTimeout(timer);
  }, [activeTab]);

  const data = {
    "Digital Engineering": [
      {
        title: "Product Engineering",
        desc: "End-to-end design, development, and lifecycle management of innovative products using next-gen tools and digital platforms.",
        color: "#e3f2fd",
      },
      {
        title: "Cloud & Edge Computing",
        desc: "Delivering scalable, secure, and agile solutions with cloud-native applications and real-time processing at the edge.",
        color: "#fff3e0",
      },
      {
        title: "IoT Solutions",
        desc: "Connecting devices, sensors, and systems to create smart factories, intelligent homes, and data-driven enterprises.",
        color: "#f3e5f5",
      },
    ],
    "AI & Data": [
      {
        title: "Artificial Intelligence",
        desc: "Driving digital transformation with AI-powered analytics, automation, and intelligent decision-making systems.",
        color: "#e8f5e9",
      },
      {
        title: "Big Data & Analytics",
        desc: "Unlocking actionable insights from massive datasets through advanced analytics, machine learning, and visualization.",
        color: "#fce4ec",
      },
      {
        title: "Cybersecurity & Data Privacy",
        desc: "Ensuring trusted digital ecosystems with advanced security frameworks, encryption, and threat intelligence.",
        color: "#ede7f6",
      },
    ],
    "Emerging Technologies": [
      {
        title: "Blockchain & Web3",
        desc: "Enabling trust, transparency, and decentralization in digital ecosystems with blockchain and distributed ledgers.",
        color: "#fff9c4",
      },
      {
        title: "5G & Next-Gen Connectivity",
        desc: "Powering ultra-fast, low-latency networks to support IoT, smart cities, autonomous vehicles, and immersive experiences.",
        color: "#c8e6c9",
      },
      {
        title: "Extended Reality (AR/VR/MR)",
        desc: "Reimagining customer engagement, training, and simulations with immersive augmented and virtual reality solutions.",
        color: "#ffcdd2",
      },
    ],
  };

  const styles = {
    container: {
      padding: "40px",
      fontFamily: "Arial, sans-serif",
      maxWidth: "100%",
      margin: "0 auto",
      backgroundColor: "white",
    },
    heading: {
      fontSize: "36px",
      fontWeight: "bold",
      marginBottom: "20px",
      textAlign: "left",
      letterSpacing: "0px",
    },
    tabs: {
      display: "flex",
      gap: "30px",
      marginBottom: "30px",
      flexWrap: "wrap",
    },
    tab: (isActive) => ({
      fontSize: "18px",
      fontWeight: isActive ? "bold" : "normal",
      cursor: "pointer",
      borderBottom: isActive ? "2px solid red" : "none",
      color: isActive ? "#000" : "gray",
      paddingBottom: "5px",
      transition: "0.3s",
    }),
    cards: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
    },
    card: (bgColor, index) => ({
      background: bgColor,
      padding: "20px",
      borderRadius: "10px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      transform: animate
        ? `translateY(${index % 2 === 0 ? "30px" : "-30px"})`
        : "translateY(0)",
      opacity: animate ? 0 : 1,
      animation: animate ? `waveIn 0.8s ease forwards ${index * 0.2}s` : "none",
      minHeight: "230px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    }),
    cardTitle: {
      fontSize: "20px",
      fontWeight: "bold",
      marginBottom: "15px",
      letterSpacing: "0px",
    },
    cardText: {
      fontSize: "16px",
      lineHeight: "1.5",
      marginBottom: "15px",
      flexGrow: 1,
      textAlign: "justify",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Hi-Tech Services</h1>

      {/* Tabs */}
      <div style={styles.tabs}>
        {Object.keys(data).map((tab) => (
          <div
            key={tab}
            style={styles.tab(activeTab === tab)}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>

      {/* Cards */}
      <div style={styles.cards}>
        {data[activeTab].map((item, index) => (
          <div key={index} style={styles.card(item.color, index)}>
            <div>
              <h2 style={styles.cardTitle}>{item.title}</h2>
              <p style={styles.cardText}>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Inline keyframes */}
      <style>
        {`
          @keyframes waveIn {
            0% { transform: translateY(50px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }
          
          @media (max-width: 768px) {
            .services-container {
              padding: 20px;
            }
            
            .services-heading {
              font-size: 28px;
            }
            
            .services-tabs {
              gap: 15px;
            }
            
            .services-cards {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Hitechservices;
